import React, { useEffect, useState } from 'react';
import { Package } from 'lucide-react';
import marketApi from './marketApi';

const STATUS = {
  pending:    { label: 'En attente',       color: '#FFB900' },
  accepted:   { label: 'Acceptée',         color: '#FF7800' },
  preparing:  { label: 'En préparation',   color: '#FF7800' },
  ready:      { label: 'Prête',            color: '#FF5500' },
  picked_up:  { label: 'Récupérée',        color: '#F54119' },
  delivering: { label: 'En livraison',     color: '#F54119' },
  delivered:  { label: 'Livrée ✓',         color: '#10B981' },
  cancelled:  { label: 'Annulée',          color: '#DC2626' },
  failed:     { label: 'Échec',            color: '#DC2626' },
};

export default function OrdersPage({ nav }) {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    let alive = true;
    marketApi.myOrders()
      .then(r => { if (alive) setOrders(r?.orders || []); })
      .catch(() => { if (alive) setOrders([]); });
    return () => { alive = false; };
  }, []);

  if (orders === null) return <div className="mk-center"><div className="mk-spin" /> Chargement…</div>;
  if (!orders.length) {
    return (
      <div className="mk-container">
        <div className="mk-center">
          <Package size={44} />
          <b>Aucune commande pour le moment</b>
          <button className="mk-btn primary" onClick={() => nav({ page: 'home' })}>Découvrir le marché</button>
        </div>
      </div>
    );
  }

  return (
    <div className="mk-container">
      <div className="mk-panel" style={{ marginTop: 18 }}>
        <h3>Mes commandes de livraison</h3>
        {orders.map(o => {
          const st = STATUS[o.status] || { label: o.status, color: '#5C636E' };
          return (
            <div className="mk-line" key={o.order_id} style={{ cursor: 'pointer' }} onClick={() => nav({ page: 'order', orderId: o.order_id })}>
              <div className="info">
                <div className="name">#{(o.order_public_id || o.order_number || o.order_id).toString().slice(-8)} · {o.supplier?.business_name || 'Commerce'}</div>
                <div className="opt">{new Date(o.created_at).toLocaleString('fr-FR')} · {o.items?.length || 0} article(s)</div>
                <div className="price">{(o.total || 0).toLocaleString('fr-FR')} FC</div>
              </div>
              <span className="mk-open" style={{ background: `${st.color}1c`, color: st.color }}>{st.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
